import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import InventoryTransactionService from "services/InventoryTransactionService";

export const getInventoryTransactionHistory = createAsyncThunk(
  "inventoryTransaction/getInventoryTransactionHistory",
  async (data, { rejectWithValue }) => {
    try {
      const response = await InventoryTransactionService.history(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getInventoryTransactionSummary = createAsyncThunk(
  "inventoryTransaction/getInventoryTransactionSummary",
  async (data, { rejectWithValue }) => {
    try {
      const response = await InventoryTransactionService.summary(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  loadingSummary: false,
  historyList: {
    pageIndex: 1,
    totalPages: 0,
    totalItems: 0,
    pageSize: 10,
    items: [],
    hasPreviousPage: false,
    hasNextPage: false,
  },
  summary: {
    openingQuantity: 0,
    totalImport: 0,
    totalExport: 0,
    totalAdjust: 0,
    closingQuantity: 0,
    hasHistoryBeforePeriod: false,
  },
};

export const inventoryTransactionSlice = createSlice({
  name: "inventoryTransaction",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setInventoryTransactionHistory: (state, action) => {
      state.historyList = action.payload;
    },
    clearInventoryTransaction: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInventoryTransactionHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInventoryTransactionHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.historyList = action.payload || initialState.historyList;
      })
      .addCase(getInventoryTransactionHistory.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getInventoryTransactionSummary.pending, (state) => {
        state.loadingSummary = true;
      })
      .addCase(getInventoryTransactionSummary.fulfilled, (state, action) => {
        state.loadingSummary = false;
        state.summary = action.payload || initialState.summary;
      })
      .addCase(getInventoryTransactionSummary.rejected, (state) => {
        state.loadingSummary = false;
      });
  },
});

export const { showLoading, setInventoryTransactionHistory, clearInventoryTransaction } = inventoryTransactionSlice.actions;

export default inventoryTransactionSlice.reducer;